export default "__VITE_ASSET__HAwZnQ40A17rYC3Q$lxt9A__$_?component__"